
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/district-reviews/[city]/[...params]",
      function () {
        return require("private-next-pages/district-reviews/[city]/[...params].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/district-reviews/[city]/[...params]"])
      });
    }
  